import React, { useEffect, useRef,useContext, useState } from 'react';
import Header from './Header';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { SearchRoutes, userRoutes, UpsellRoutes, AIAssistantRoutes, CmsAssistantRoutes, AiVisibilityRoutes} from '../Routes';
import { ProductContext } from '../store';
import DetailSkeleton from './Skeleton/DetailSkeleton';
const Content = ({type}) => {
	const [websitePlatform, setWebsitePlatform] = useState("")
	const {
		loadVisualEditor,
		userLoader,
		currentWebsiteId,
		websiteData,
		userWebsitePlan,
		productTypes
		} = useContext(ProductContext);
	const mainContent	= useRef(null),
		location	= useLocation()

	useEffect(() => {
		if(userLoader || !userWebsitePlan || !Array.isArray(userWebsitePlan) || userWebsitePlan.length === 0){
			return
		}
		if(currentWebsiteId){
			setWebsitePlatform(websiteData[currentWebsiteId]?.websiteType)
		}
	}, [currentWebsiteId, userLoader, userWebsitePlan, websiteData])

	useEffect(() => {
		document.documentElement.scrollTop = 0;
		document.scrollingElement.scrollTop = 0;
		if( mainContent.current ){
			mainContent.current.scrollTop = 0;
		}
	}, [location]);

	const getRoutes = () => {
		let returnRoutes	= null
		try {
			if( type === "search" ){
				// Check if routes are available and is an array
				if (!SearchRoutes || !Array.isArray(SearchRoutes)) {
					console.error('SearchRoutes is not available or not an array');
					return null;
				}
				// Check if user has search product type
				returnRoutes = SearchRoutes.map((searchRoute, key) => {
				return (
					<React.Fragment key={key}>
						{(!searchRoute.accessPlans || (searchRoute.accessPlans && userWebsitePlan && Array.isArray(userWebsitePlan) && userWebsitePlan.some(plan => searchRoute.accessPlans.includes(plan.planId)))) && productTypes && Array.isArray(productTypes) && productTypes.includes("search") && (searchRoute.component || (searchRoute.subMenu && Array.isArray(searchRoute.subMenu))) && (
							<React.Fragment>
								{searchRoute.component && (
									<Route
										exact
										path={searchRoute.path}
										element={searchRoute.component}
									/>
								)}
								{searchRoute.subMenu && Array.isArray(searchRoute.subMenu) &&
									searchRoute.subMenu.map((subMenu, index) => {
										if( ( !subMenu.availablePlatforms || ( subMenu.availablePlatforms && subMenu.availablePlatforms.includes(websitePlatform) ) ) && subMenu.component ){
											return (
												<Route
													exact
													path={subMenu.path}
													element={subMenu.component}
													key={index}
												/>
											)
										}
										return null;
									})
								}
								{key + 1 === SearchRoutes.length &&
									<Route path="*" element={<Navigate to="/search/dashboard" replace />} />
								}
							</React.Fragment>
						)
					}
					</React.Fragment>
				);
			})
			} else if( type === "upsell" ){
				// Check if routes are available and is an array
				if (!UpsellRoutes || !Array.isArray(UpsellRoutes)) {
					console.error('UpsellRoutes is not available or not an array');
					return null;
				}
				returnRoutes = UpsellRoutes.map((upsellRoute, key) => {
				return (
					<React.Fragment key={key}>
						{(!upsellRoute.accessPlans || (upsellRoute.accessPlans && userWebsitePlan && Array.isArray(userWebsitePlan) && userWebsitePlan.some(plan => upsellRoute.accessPlans.includes(plan.planId)))) && (
							<React.Fragment>
								{upsellRoute.component && (
									<Route
										exact
										path={upsellRoute.path}
										element={upsellRoute.component}
									/>
								)}
								{upsellRoute.subMenu && Array.isArray(upsellRoute.subMenu) &&
									upsellRoute.subMenu.map((subMenu, index) => {
										if( ( !subMenu.availablePlatforms || ( subMenu.availablePlatforms && subMenu.availablePlatforms.includes(websitePlatform) ) ) && subMenu.component ){
											return (
												<Route
													exact
													path={subMenu.path}
													element={subMenu.component}
													key={index}
												/>
											)
										}
										return null;
									})
								}
								{key + 1 === UpsellRoutes.length &&
									<Route path="*" element={<Navigate to="/upsell/dynamic" replace />} />
								}
							</React.Fragment>
						)
					}
					</React.Fragment>
				);
			})
			} else if( type === "aiassistant" ){
				// Check if routes are available and is an array
				if (!AIAssistantRoutes || !Array.isArray(AIAssistantRoutes)) {
					console.error('AIAssistantRoutes is not available or not an array');
					return null;
				}
				returnRoutes = AIAssistantRoutes.map((aiRoute, key) => {
				return (
					<React.Fragment key={key}>
						{(!aiRoute.accessPlans || (aiRoute.accessPlans && userWebsitePlan && Array.isArray(userWebsitePlan) && userWebsitePlan.some(plan => aiRoute.accessPlans.includes(plan.planId)))) && productTypes && Array.isArray(productTypes) && productTypes.includes("aiassistant") && (
							<React.Fragment>
								{aiRoute.component && (
									<Route
										exact
										path={aiRoute.path}
										element={aiRoute.component}
									/>
								)}
								{aiRoute.subMenu && Array.isArray(aiRoute.subMenu) &&
									aiRoute.subMenu.map((subMenu, index) => {
										if( ( !subMenu.availablePlatforms || ( subMenu.availablePlatforms && subMenu.availablePlatforms.includes(websitePlatform) ) ) && subMenu.component ){
											return (
												<Route
													exact
													path={subMenu.path}
													element={subMenu.component}
													key={index}
												/>
											)
										}
										return null;
									})
								}
								{key + 1 === AIAssistantRoutes.length &&
									<Route path="*" element={<Navigate to="/aiassistant/responses" replace />} />
								}
							</React.Fragment>
						)
					}
					</React.Fragment>
				);
			})
			}else if( type === "aivisibility" ){
				returnRoutes = (
					<>
						{AiVisibilityRoutes.map((route, key) => {
							return (
								<React.Fragment key={key}>
									{productTypes && productTypes.includes("aivisibility") && (
										<React.Fragment>
											{/* Single Monitoring instance for all sections — avoids remount flicker */}
											{route.name === "Monitoring" && route.component ? (
												<Route
													path="/monitoring/*"
													element={route.component}
												/>
											) : (
												<>
													{route.path && route.component && (
														<Route
															exact
															path={route.path}
															element={route.component}
														/>
													)}
													{route.subMenu && Array.isArray(route.subMenu) &&
														route.subMenu.map((subMenu, index) => {
															if (
																(!subMenu.availablePlatforms ||
																	(subMenu.availablePlatforms &&
																		subMenu.availablePlatforms.includes(websitePlatform))) &&
																subMenu.component
															) {
																return (
																	<Route
																		exact
																		path={subMenu.path}
																		element={subMenu.component}
																		key={index}
																	/>
																);
															}
															return null;
														})
													}
												</>
											)}
										</React.Fragment>
									)}
								</React.Fragment>
							);
						})}
						{productTypes && productTypes.includes("aivisibility") && (
							<>
								<Route path="/dashboard" element={<Navigate to="/aivisibility/audit-list" replace />} />
								<Route path="*" element={<Navigate to="/aivisibility/audit-list" replace />} />
							</>
						)}
					</>
				);
			}else if( type === "cmsassistant" ){
				returnRoutes = (
					<>
						{CmsAssistantRoutes.map((cmsRoute, key) => {
							return (
								<React.Fragment key={key}>
									{(!cmsRoute.accessPlans || (cmsRoute.accessPlans && userWebsitePlan && Array.isArray(userWebsitePlan) && userWebsitePlan.some(plan => cmsRoute.accessPlans.includes(plan.planId)))) && productTypes && productTypes.includes("cmsassistant") &&(
										<React.Fragment>
											{cmsRoute.path && (
												<Route
													exact
													path={cmsRoute.path}
													element={cmsRoute.component}
												/>
											)}
											{cmsRoute.subMenu && Array.isArray(cmsRoute.subMenu) &&
												cmsRoute.subMenu.map((subMenu, index) => {
													if( ( !subMenu.availablePlatforms || ( subMenu.availablePlatforms && subMenu.availablePlatforms.includes(websitePlatform) ) ) && subMenu.component ){
														return (
															<Route
																exact
																path={subMenu.path}
																element={subMenu.component}
																key={index}
															/>
														)
													}
													return null;
												})
											}
											{key + 1 === cmsRoute.length &&
												<Route path="*" element={<Navigate to="/cmsassistant/dashboard" replace />} />
											}
										</React.Fragment>
									)
								}
								</React.Fragment>
							);
						})}
						{productTypes && productTypes.includes("cmsassistant") && (
							<Route path="*" element={<Navigate to="/cmsassistant/dashboard" replace />} />
						)}
					</>
				);
			} else {
				// Check if routes are available and is an array
				if (!userRoutes || !Array.isArray(userRoutes)) {
					console.error('userRoutes is not available or not an array');
					return null;
				}
				returnRoutes = userRoutes.map((prop, key) => {
										return (
											<>
												{prop.component && (
													<Route
														exact
														path={prop.path}
														element={prop.component}
														key={key}
													/>
												)}
												{key + 1 === userRoutes.length &&
													<Route path="*" element={<Navigate to="/user/dashboard" replace />} />
												}
											</>
										);
									})
			}
		} catch (error) {
			console.error('Error in getRoutes:', error);
			return null;
		}
		return returnRoutes
	}
	return (
		<div className='contentMainContainer' ref={mainContent}>
			<Header />
			<div className={loadVisualEditor?'pageContentWrapperNoPadding':'pageContentWrapper'}>
				<div className='pageContentInnerWrapper'>
					{userLoader || !userWebsitePlan || !Array.isArray(userWebsitePlan) || userWebsitePlan.length === 0 ?
						<DetailSkeleton />
					:
						<Routes>
							{getRoutes()}						
						</Routes>
					}
				</div>
			</div>
		</div>
	);
}

export default Content;